const isDevDataEnvironment =
  process.env.REACT_APP_DATA_ENVIRONMENT === 'dev' ||
  process.env.REACT_APP_FIREBASE_DATA_ENV === 'dev';

/** live | dev — matches redeem_promo_code dataEnvironment */
export const DATA_ENVIRONMENT = isDevDataEnvironment ? 'dev' : 'live';

const promoCollection = (liveName, devName) =>
  DATA_ENVIRONMENT === 'dev' ? devName : liveName;

export const PROMO_SPEC_COLLECTION = promoCollection(
  'promo_codes',
  'dev_promo_codes'
);
export const PROMO_REDEMPTIONS_SPEC = promoCollection(
  'promoRedemptions',
  'dev_promoRedemptions'
);

/** Admin panel always uses promo_codes (same as Cloud Function inventory). */
export const ADMIN_PROMO_COLLECTION =
  process.env.REACT_APP_PROMO_COLLECTION || PROMO_SPEC_COLLECTION;

export const COLLECTIONS = {
  USERS: 'users',
  SUBSCRIPTIONS: 'subscriptions',
  FILTERS: 'filters',
  USERNAMES: 'usernames',
  CONVERSATIONS: 'conversations',
  BLOCKS: 'blocks',
  CONTACTS: 'contacts',
  FAVORITES: 'favorites',
  ALBUMS: 'albums',
  TAPS: 'taps',
  PRESENCE: 'presence',
  PROFILE_CARDS: 'profileCards',
  PROFILE_IMAGE_VIEWS: 'profileImageViews',
  ADMINS: 'admins',
  AUDIT_LOGS: 'adminAuditLogs',
  PROMO_CODES: ADMIN_PROMO_COLLECTION,
  PROMO_REDEMPTIONS: PROMO_REDEMPTIONS_SPEC,
  LEGAL_CONTENT: 'legal_content',
  ADMIN_SETTINGS: 'adminSettings',
  APP_CATEGORIES: 'app-categories',
};
